import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MobileWarning } from '@/components/MobileWarning';
import './app.css';

interface AppWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper pour l'application (Dashboard, Settings, etc.)
 * Importe les styles spécifiques à l'app et gère l'overflow
 * Affiche un avertissement sur mobile (sauf pour les formulaires publics)
 */
export function AppWrapper({ children }: AppWrapperProps) {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Routes qui doivent rester accessibles sur mobile
  const mobileAllowedRoutes = [
    '/submit-referents/',
    '/referent/',
    '/attestation-upload/',
    '/candidate-report/',
    '/unsubscribe/',
  ];

  // Vérifier si la route actuelle est autorisée sur mobile
  const isMobileAllowedRoute = mobileAllowedRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  useEffect(() => {
    // Fonction pour vérifier si on est sur mobile
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768); // 768px = breakpoint md de Tailwind
    };

    // Vérifier au montage
    checkIfMobile();

    // Écouter les changements de taille d'écran
    window.addEventListener('resize', checkIfMobile);

    // Appliquer overflow-x: hidden uniquement pour l'app
    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';
    
    // Cleanup : restaurer quand on quitte l'app
    return () => {
      window.removeEventListener('resize', checkIfMobile);
      document.documentElement.style.overflowX = '';
      document.body.style.overflowX = '';
    };
  }, []);

  // Si on est sur mobile ET que ce n'est pas une route autorisée, afficher l'avertissement
  if (isMobile && !isMobileAllowedRoute) {
    return <MobileWarning />;
  }
  
  return <>{children}</>;
}
